import component from './WorkspaceDropdown.vue'
export default component
